import { call, put, takeLatest } from 'redux-saga/effects';
import { TaxesActionType, TaxesActions } from './actions';
import { getTaxes, createTaxesReport, GetTaxesResponse } from '@card/commonlib';

function* fetchTaxes(action: ReturnType<typeof TaxesActions.fetchStarted>) {
  try {
    const taxes: GetTaxesResponse = yield call(getTaxes, action.payload);
    yield put(TaxesActions.fetchSuccess(taxes));
  } catch (error) {
    yield put(TaxesActions.fetchError(error));
  }
}

function* createReport(action: ReturnType<typeof TaxesActions.createReportStarted>) {
  try {
    yield call(createTaxesReport, action.payload);
  } catch (error) {
    yield put(TaxesActions.createReportError(error));
  }
}

export function* taxesSagas() {
  yield takeLatest(TaxesActionType.FetchStarted, fetchTaxes);
  yield takeLatest(TaxesActionType.CreateReportStarted, createReport);
}
